module.exports = __webpack_public_path__ + "img/cover-fondsindeppress.b0cb983f.jpg";